import React from 'react';

import { styled, Tab as MaterialTab } from '@mui/material';

export interface TabProps {
  value: string;
  label: string | JSX.Element;
  disabled?: boolean;
  onClick?: () => void;
  style?: any;
}

export const Tab = styled((props: TabProps) => <MaterialTab {...props} />)(({}) => ({
  textTransform: 'none',
  fontWeight: '700',
  fontSize: '18px',
  fontStyle: 'normal',
  color: '#687A8C',
  height: '36px',
  fontFamily: 'Roboto',
  '&.Mui-selected': {
    color: '#070A0D',
  },
}));
